export const Constants = Object.freeze({
    /**
     * 后台服务器请求地址
     */
    hostServe: 'http://222.178.203.71:9566',
    SUCCESS: '1000',
    NETSTA_NONE: 'none',
    NOAUTH: 401
});
